import axios, { AxiosError } from 'axios'
import config from 'config'
import ApplicationStatus from 'state/enums/ApplicationStatus'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import {
    ApplicationSubmissionTimeoutError,
    ApplicationSubmissionError,
} from './types.d'

interface SubmitApplicationOptions {
    asyncSubmission?: boolean
    timeoutSeconds?: number
}

type ApplicationSubmitResponse = {
    status: `${ApplicationStatus}`
    is_async_submission: boolean
    application_uuid?: string
    poll_url?: string
    type?: 'application' | 'orchestration'
}

export default async function submitApplication(
    uuid: string,
    options: SubmitApplicationOptions = {},
): Promise<ApplicationSubmitResponse> {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/client-application/${uuid}/submit/`,
            { async_submission: options.asyncSubmission },
            {
                withCredentials: true,
                timeout:
                    options.timeoutSeconds !== undefined
                        ? options.timeoutSeconds * 1000
                        : undefined,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data as ApplicationSubmitResponse
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to submit application: ${axiosError.message}`,
            axiosError,
            {
                applicationUuid: uuid,
                asyncSubmission: options.asyncSubmission,
            },
        )

        const isTimeoutError =
            axiosError.code &&
            [AxiosError.ECONNABORTED, AxiosError.ETIMEDOUT].includes(
                axiosError.code,
            )

        if (isTimeoutError) {
            throw new ApplicationSubmissionTimeoutError()
        }

        throw new ApplicationSubmissionError(axiosError.message)
    }
}
